import React from "react";
import { Box, MenuItem, Stack, TextField } from "@mui/material";
import { PASTEL } from "./livechatTheme";

export const OWNERSHIP_TABS = [
    { key: "mine", label: "Milik Saya" },
    { key: "unassigned", label: "Unassigned" },
    { key: "all", label: "Semua" },
];

// DEV-1234 — tab kepemilikan di atas filter Aktif/Belum dibaca/Selesai. Hanya dirender parent kalau
// brand aktif di ChannelRail memakai pembagian lead otomatis (autoAssignEnabled). Leader/SPV
// mendapat dropdown tambahan untuk memfilter percakapan milik 1 sales.
export default function OwnershipTabs({ value, onChange, isSupervisor, agents, agentId, onAgentChange }) {
    return (
        <Box sx={{ px: 1, pt: 0.75, pb: 0.5, borderBottom: `1px solid ${PASTEL.border}` }}>
            <Stack direction="row" spacing={0.5}>
                {OWNERSHIP_TABS.map((tab) => {
                    const isActive = value === tab.key;
                    return (
                        <Box
                            key={tab.key}
                            component="button"
                            type="button"
                            onClick={() => onChange(tab.key)}
                            sx={{
                                flex: 1, minWidth: 0, py: 0.5, border: "none", borderRadius: 1.5, cursor: "pointer",
                                fontFamily: "inherit", fontSize: 11.5, fontWeight: isActive ? 700 : 500,
                                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                backgroundColor: isActive ? PASTEL.primary : PASTEL.surfaceAlt,
                                color: isActive ? "#fff" : "text.secondary",
                                "&:hover": { backgroundColor: isActive ? PASTEL.primaryDark : PASTEL.primarySoft },
                            }}
                        >
                            {tab.label}
                        </Box>
                    );
                })}
            </Stack>
            {isSupervisor && (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label="Filter sales"
                    value={agentId ?? ""}
                    onChange={(e) => onAgentChange(e.target.value === "" ? null : Number(e.target.value))}
                    sx={{ mt: 0.75, "& .MuiInputBase-root": { fontSize: 13 } }}
                >
                    <MenuItem value="">Semua sales</MenuItem>
                    {agents.map((a) => (
                        <MenuItem key={a.userId} value={a.userId}>
                            {a.userName}
                            {a.online && a.acceptingLeads ? " • siap" : a.online ? " • online" : ""}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        </Box>
    );
}
